export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-autorizador' */ '@/views/cadastro/autorizador/Index'),
        path: 'autorizador',
        redirect: 'autorizador/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-autorizador-index' */ '@/views/cadastro/autorizador/List.vue'),
                name: 'cadastro-autorizador-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-autorizador' */ '@/views/cadastro/autorizador/Form.vue'),
                name: 'cadastro-autorizador-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-autorizador' */ '@/views/cadastro/autorizador/Form.vue'),
                name: 'cadastro-autorizador-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]
